export const CLASSIC = 'Classic'
export const CLASSICPOSTERCENTER = 'ClassicPosterCenter'
export const CLASSICPOSTERRIGHT = 'ClassicPosterRight'
export const KENBURNS = 'KenBurns'
export const KENBURNSPOSTERCENTER = 'KenBurnsPosterCenter'
export const KENBURNSPOSTERRIGHT = 'KenBurnsPosterRight'